import React, { useState, useEffect } from 'react';
import { HiX } from 'react-icons/hi'

const WordTag = ({ visible, onClose, onSave, word }) => {
  const [editedProperties, setEditedProperties] = useState({ original: '', target: '', synt: '', lemma: '' });
  const pos = ['ADJ', 'ADV', 'DET', 'CON', 'NOM', 'PRO', 'PRE', 'PON', 'VER']

  useEffect(() => {
    // Update the edited properties when the word prop changes
    if (word[5]) {
      setEditedProperties({ original: word[0], target: word[2], synt: word[3], lemma: word[4], index: word[5] });
    } else {
      setEditedProperties({ original: word[0], target: word[1], synt: word[2], lemma: word[3], index: word[4] });
    }
  }, [word]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedProperties((prev) => ({ 
      ...prev, 
      [name]: value 
    }));
  };

  const handleSave = () => {
    // Save the edited properties and close the modal
    onSave(editedProperties);
    onClose();
  };

  return (
    <div className={`modal ${visible ? 'block' : 'hidden'} py-4`}>
      <div className="py-4 p-2.5 bg-white block w-full rounded-md border border-gray-300 shadow-sm"> 
        <div className="modal-content">
            <button
              className="block px-4 rounded-md border border-gray-300 py-1.5 shadow-sm text-xl font-medium text-gray-900 hover:bg-gray-100"
              type="button"
              onClick={onClose}
              >
              <HiX />
            </button>
          <label htmlFor="last-name" className="block text-sm font-medium leading-6 text-gray-900">
            Mot produit
          </label>
          <p className="w-full block rounded-md border border-gray-300 py-1.5 shadow-sm p-2.5">{editedProperties.original}</p>
          <label htmlFor="last-name" className="block text-sm font-medium leading-6 text-gray-900">
            Mot cible
          </label>
          <input
            type="text"
            name="target"
            value={editedProperties.target}
            onChange={handleInputChange}
            className="w-full block rounded-md border border-gray-300 py-1.5 shadow-sm"
          />
          <label htmlFor="last-name" className="block text-sm font-medium leading-6 text-gray-900">
            Catégorie
          </label>
          <select
            name="synt"
            value={editedProperties.synt}
            onChange={handleInputChange}
            className="w-full block rounded-md border border-gray-300 py-1.5 shadow-sm"
          >
          {pos.map((pos) => (
            <option key={pos} value={pos}>
              {pos}
            </option>
          ))}
          </select>
          <label htmlFor="last-name" className="w-full block text-sm font-medium leading-6 text-gray-900">
            Lemme
          </label>
          <input
            type="text"
            name="lemma"
            value={editedProperties.lemma}
            onChange={handleInputChange}
            className="w-full block rounded-md border border-gray-300 py-1.5 shadow-sm"
          />
          <button
            className="w-full block rounded-md border border-gray-300 mt-2 py-1.5 shadow-sm text-sm font-medium text-gray-900 hover:bg-gray-100"
            type="submit"
            onClick={handleSave}
            >
              Sauvegarder
          </button>
        </div>
      </div>
    </div>
  );
};

export default WordTag;
